export const vehiclesCompare = '/vehicles/compare'
export const vehicles = '/vehicles'
export const vehiclesId = '/vehicles/:id'
export const vehiclesEcus =
  '/vehicles/:id/ecus/:moduleName/:connectorName/:location?'
export const featuresId = '/features/:featureId'
export const features = '/features'
export const pto = '/pto'
export const switchAndGauge = '/switchandgauge'
export const referenceParametersRPNumRelease =
  '/reference-parameters/:refParameterNumber/:releaseNumber'
export const referenceParameters = '/reference-parameters'
export const rpCollections = '/rp-collections'
export const featureCollections = '/feature-collections'
export const featureCollectionsId = '/feature-collections/:collectionId'
export const supportParametersSPNum = '/support-parameters/:supParameterNumber'
export const supportParameters = '/support-parameters'
export const checFeatures = '/chec-features'
export const alerts = '/alerts'
export const circuitsId = '/circuits/:id'
export const bundlesId = '/bundles/:id'
export const ctp = '/ctp'
export const ptoTemplates = '/pto-templates'
export const ptoTemplatesId = '/pto-templates/:id'
export const requirements = '/requirements'
export const signals = '/inputs'
export const releaseNotes = '/release-notes'
export const dashLayout = '/dash-layout'
export const dashBuilderId = '/dash-layout/:id'
export const odxDataTranslator = '/odx-data-translator'
export const odxModule = '/odx-data-translator/:module'
export const odxVariant = '/odx-data-translator/:module/:variant'
export const odxDomains = '/odx-data-translator/:module/:variant'
export const odxVCDQualifier =
  '/odx-data-translator/:module/:variant/:vcdQualifier'
export const odxFragment =
  '/odx-data-translator/:module/:variant/:vcdQualifier/:fragment'
export const odxDomainPartNumbers =
  '/odx-data-translator/:module/:variant/:vcdQualifier/keys'
export const odxDomainPartNumber =
  '/odx-data-translator/:module/:variant/keys/:key'
export const parts = '/parts'
export const partsId = '/parts/:id'
export const temEnablement = '/tem_enablement'
export const lineNoteReader = '/line-note-reader'
export const errors = '/errors/:error'
export const fastFeatureErrors = '/fast-feature-errors'
export const rules = '/rules'
export const rolesEditor = '/roles'
